import React, { useState } from 'react';
import { Play } from 'lucide-react';

/**
 * Lazy-load YouTube embed using high-quality thumbnail + custom play button.
 * Hides the YouTube title/channel overlay until the user clicks to play.
 * After clicking, the iframe loads with autoplay=1.
 */
const YouTubeLazy = ({ videoId, testid }) => {
  const [playing, setPlaying] = useState(false);
  // sddefault is 640x480 and guaranteed; falls back to hqdefault if not available
  const thumb = `https://i.ytimg.com/vi/${videoId}/sddefault.jpg`;
  const fallbackThumb = `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;

  return (
    <div
      className="relative bg-black rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-shadow aspect-video"
      data-testid={testid}
    >
      {!playing ? (
        <button
          type="button"
          onClick={() => setPlaying(true)}
          className="group absolute inset-0 w-full h-full"
          aria-label="Lire la vidéo"
        >
          <img
            src={thumb}
            onError={(e) => { e.currentTarget.src = fallbackThumb; }}
            alt=""
            className="absolute inset-0 w-full h-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
            <div className="w-20 h-20 bg-red-600 rounded-full flex items-center justify-center shadow-2xl group-hover:scale-110 transition-transform">
              <Play className="h-9 w-9 text-white ml-1" fill="currentColor" />
            </div>
          </div>
        </button>
      ) : (
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&showinfo=0&iv_load_policy=3`}
          title="Témoignage"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          className="absolute inset-0 w-full h-full"
        />
      )}
    </div>
  );
};

export default YouTubeLazy;
